import { useCallback, useRef } from "react";
import { useStartWorkflow } from "~/workflows/ActiveWorkflowsProvider";
import type { Workflow } from "~/workflows/workflows";
export function useWorkflow<Input, Output>(workflow: Workflow<Input, Output>, onWorkflowCompleted: (output: Output) => void): StartWorkflow<Input> {
    const startWorkflow = useStartWorkflow();
    // Capture the workflow so that useCallback doesn't need it in the dependency array. This means the hook doesn't respond to changes to this parameter type
    // which is not something any consumers should be doing.
    const workflowRef = useRef(workflow);
    // Capture the completed callback in a ref so that useCallback doesn't need it in the dependency array.
    const onWorkflowCompletedRef = useRef(onWorkflowCompleted);
    // This causes the completion of the workflow to use the latest instance of the function supplied to this hook, rather than the
    // instance of the function captured at the point when the workflow is initiated
    onWorkflowCompletedRef.current = onWorkflowCompleted;
    return useCallback<StartWorkflow<Input>>((input) => {
        startWorkflow(input, workflowRef.current, onWorkflowCompletedRef.current);
    }, [startWorkflow]);
}
export type StartWorkflow<Input> = (input: Input) => void;
